module.exports = __webpack_public_path__ + "fonts/weathericons-regular-webfont.4618f0de.ttf";